import { render, staticRenderFns } from "./ControlledDrugsRegisterRep.vue?vue&type=template&id=38669d70&"
import script from "./ControlledDrugsRegisterRep.vue?vue&type=script&lang=js&"
export * from "./ControlledDrugsRegisterRep.vue?vue&type=script&lang=js&"
import style0 from "./ControlledDrugsRegisterRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports